import useFetch from '../../../hooks/useFetch';
import { ServiceEvents } from '../shared/interfaces';
import { useState } from 'react';
import { EndPoints } from '../EndPoints';
import { Transport, TransportFilters, TransportDataForm } from '../../models/Transport';
import { DeliveryFilters } from '../../models/Delivery';

const useTransportService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetTransports, setFetchingGetTransports] = useState(false);
    const [fetchingStoreTransport, setFetchingStoreTransport] = useState(false);
    const [fetchingEditTransport, setFetchingEditTransport] = useState(false);
    const [fetchingUpdateTransport, setFetchingUpdateTransport] = useState(false);
    const [fetchingDeleteTransport, setFetchingDeleteTransport] = useState(false);
    const [fetchingActiveTransport, setFetchingActiveTransport] = useState(false);
    const [fetchingGetAvailableDeliveries, setFetchingGetAvailableDeliveries] = useState(false);

    const getTransports = (filter: TransportFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(filter)
            .filter(([, value]) => value !== undefined && value !== '' && value !== null)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        const url = EndPoints.TRANSPORTS.GET_TRANSPORTS + (queryString ? '?' + queryString : '');

        doGet({
            ...events,
            url: url,
            setFetching: setFetchingGetTransports
        });
    };

    const storeTransport = (transport: TransportDataForm, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.TRANSPORTS.STORE_TRANSPORT,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            requestType: 'json',
            body: transport,
            setFetching: setFetchingStoreTransport
        });
    };

    const editTransport = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.TRANSPORTS.EDIT_TRANSPORT.replace(':id', id.toString()),
            setFetching: setFetchingEditTransport
        });
    };

    const updateTransport = (id: number, transport: TransportDataForm, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.TRANSPORTS.UPDATE_TRANSPORT.replace(':id', id.toString()),
            body: transport,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            requestType: 'json',
            setFetching: setFetchingUpdateTransport
        });
    };

    const deleteTransport = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.TRANSPORTS.DELETE_TRANSPORT.replace(':id', id.toString()),
            setFetching: setFetchingDeleteTransport
        });
    };

    const activeTransport = (id: number, active: boolean, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.TRANSPORTS.ACTIVE_TRANSPORT.replace(':id', id.toString()),
            body: { active: active },
            setFetching: setFetchingActiveTransport
        });
    };

    const getAvailableDeliveries = (filters: DeliveryFilters & { transport_id?: number }, events: ServiceEvents = {}) => {
        const queryString = Object.entries(filters)
            .filter(([, value]) => value !== undefined && value !== '' && value !== null)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        const url = EndPoints.TRANSPORTS.GET_AVAILABLE_DELIVERIES + (queryString ? '?' + queryString : '');

        doGet({
            ...events,
            url: url,
            setFetching: setFetchingGetAvailableDeliveries
        });
    };

    return {
        fetchingGetTransports,
        fetchingStoreTransport,
        fetchingEditTransport,
        fetchingUpdateTransport,
        fetchingDeleteTransport,
        fetchingActiveTransport,
        fetchingGetAvailableDeliveries,
        getTransports,
        storeTransport,
        editTransport,
        updateTransport,
        deleteTransport,
        activeTransport,
        getAvailableDeliveries
    };
};

export default useTransportService;
